import type Keycloak from "keycloak-js";
import { withSignupRoleRequestParam } from "./signup/signupRole.js";

const installed = new WeakSet<Keycloak>();

/**
 * Adds the signup role from the app's `ot` to every login and registration URL
 * this keycloak-js instance builds, as `signup_as`. keycloak-js has no option
 * for custom authorization parameters, but its default adapter and the
 * Capacitor adapter both build their URLs through `createLoginUrl`.
 */
export function installSignupRoleRequestParam(
  keycloak: Keycloak,
  getSearch: () => string = () => window.location.search
): void {
  if (installed.has(keycloak)) {
    return;
  }
  installed.add(keycloak);
  const createLoginUrl = keycloak.createLoginUrl.bind(keycloak);
  keycloak.createLoginUrl = async options =>
    withSignupRoleRequestParam(await createLoginUrl(options), getSearch());
}
